import { v4 as uuid } from 'uuid';

import { store } from 'app/redux';
import { AuthActionType } from 'app/page/auth/redux/model/auth-action-type';
import { config } from 'app/config/config';
import { PkceUtils } from 'app/utils/pkce-utils';

class AuthService {
    public static authorize(): void {
        const { authUrl, scope, clientId, redirectUri, authTheme } = config.auth;
        const state = uuid();
        const { codeChallenge, codeVerifier } = PkceUtils.generateCodeChallengeAndCodeVerifier();
        const appLanguage = config.LANGUAGE;

        store.dispatch({
            type: AuthActionType.AUTHORIZE_START,
            stateParam: state,
            codeVerifier,
        });

        const url = new URL(authUrl);
        const params = url.searchParams;

        params.append('client_id', clientId);
        params.append('redirect_uri', redirectUri);
        params.append('response_type', 'code');
        params.append('scope', scope);
        params.append('state', state);
        params.append('code_challenge_method', 'S256');
        params.append('code_challenge', codeChallenge);
        params.append('locale', appLanguage);
        params.append('theme', authTheme);

        window.location.assign(url.toString());
    }

    public static getAccessToken(): string | undefined {
        return store.getState().auth?.authToken?.access_token;
    }

    public static isAuthenticated(): boolean {
        return !!AuthService.getAccessToken();
    }
}

export { AuthService };
